// ============================================================
//  MEGA MENU - COMPLETE JS
//  1. Right-side category columns accordion (mobile)
//  2. Left sidebar submenu toggle (RUGS, HOME TEXTILE, etc.)
//  3. Mobile rugs nav link toggle
// ============================================================

// ── Right-side category columns ──────────────────────────────
const categoryColumns = document.querySelectorAll('.category-column');

window.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 768) {
    categoryColumns.forEach(col => {
      col.classList.remove('open');
    });
  }
});

categoryColumns.forEach(column => {
  const heading = column.querySelector('h3');
  if (!heading) return;

  heading.addEventListener('click', function () {
    if (window.innerWidth <= 768) {
      const isOpen = column.classList.contains('open');

      categoryColumns.forEach(col => {
        col.classList.remove('open');
      });

      if (!isOpen) {
        column.classList.add('open');
      }
    }
  });
});

window.addEventListener('resize', function () {
  if (window.innerWidth > 768) {
    categoryColumns.forEach(col => {
      col.classList.remove('open');
    });
  }
});


// ── Left Sidebar Submenu Toggle (RUGS, HOME TEXTILE, etc.) ───
function toggleSubmenu(itemId) {
  const item = document.getElementById(itemId);
  if (!item) return;

  const isOpen = item.classList.contains('open');
  const icon = item.querySelector('.toggle-icon');

  // Close all other open submenus first
  document.querySelectorAll('.sidebar-item.has-submenu.open').forEach(function (el) {
    if (el.id !== itemId) {
      el.classList.remove('open');
      const otherIcon = el.querySelector('.toggle-icon');
      if (otherIcon) otherIcon.textContent = '+';
    }
  });

  // Toggle current item
  if (isOpen) {
    item.classList.remove('open');
    if (icon) icon.textContent = '+';
  } else {
    item.classList.add('open');
    if (icon) icon.textContent = '−';
  }
}


// ── Mobile: Rugs nav link toggle ─────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  // .rugs-link click → toggle .menu-item.has-mega
  const rugsLink = document.querySelector('.rugs-link');
  const rugsMenuItem = document.querySelector('.menu-item.has-mega');

  if (rugsLink && rugsMenuItem) {
    rugsLink.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        rugsMenuItem.classList.toggle('open');
      }
    });
  }

  // .rugs-item > a click → toggle .active on parent
  const rugsItemLink = document.querySelector('.rugs-item > a');

  if (rugsItemLink) {
    rugsItemLink.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        rugsItemLink.parentElement.classList.toggle('active');
      }
    });
  }

});